import { kkBridgeCall, kkBridgeHasMethod } from '@/../../common/src/utils/jsBridge';
import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { Platform } from '@/../../common/src/utils/nativeApi/interface';
import { checkGoogleScoreReport, trackFacebookCapi } from '@/appApi';

import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import { getGlobalUserInfo } from './singletonUtils';

export enum trackType {
  SENSORS = 'sensors', // 神策
  GA4 = 'ga4', // Google Analytics 4
  PIXEL = 'pixel', // Facebook Pixel
  AF = 'appsflyer', // Appsflyer
  CAPI = 'capi', // Facebook CAPI
}

export enum CapiActionSource {
  WEBSITE = 'website',
  APP = 'app',
}

let isLCPDetermined = false;
let lcpFallbackTimer: NodeJS.Timeout;

const initLCPObserver = () => {
  // 监听LCP变化
  const lcpObserver = new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    if (entries.length > 0) {
      const latestLCP = entries[entries.length - 1];
      console.log('🚀 LCP候选元素:', latestLCP.startTime, 'ms');

      // 不立即标记，等待LCP稳定
      clearTimeout(lcpFallbackTimer);
      lcpFallbackTimer = setTimeout(() => {
        if (!isLCPDetermined) {
          isLCPDetermined = true;
          console.log('🎯 LCP确定，切换到微任务模式');
        }
      }, 500); // LCP稳定后500ms才切换
    }
  });

  try {
    lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (e) {
    console.warn('LCP Observer not supported:', e);
  }

  // 最大保护时间：4秒后强制切换（针对P95场景）
  setTimeout(() => {
    if (!isLCPDetermined) {
      isLCPDetermined = true;
      console.log('⏰ LCP最大保护时间到，强制切换');
    }
  }, 4000);
};

// 初始化
if (typeof window !== 'undefined') {
  initLCPObserver();
}

export const trackEvent = (type: Array<trackType>, eventName: string, eventParam?: any) => {
  console.log(
    '🚀 ~ trackEvent ~ type: Array<trackType>, eventName: string, eventParam?: any:',
    type,
    eventName,
    eventParam
  );

  if (!type.length) return false;
  const executeFun = () => {
    type.forEach((item) => {
      switch (item) {
        case trackType.SENSORS:
          sensors.track(eventName, eventParam);
          break;
        case trackType.GA4:
          ReactGA.event(eventName, eventParam);
          break;
        case trackType.PIXEL:
          ReactPixel.trackCustom(eventName, eventParam);
          nativeApi.fbTrackEvent?.(eventName, eventParam);
          break;
        case trackType.AF:
          nativeApi.afTrackEvent?.(eventName, eventParam);
          break;
        case trackType.CAPI:
          trackFacebookCapi({
            actionSource: [Platform.Crefit, Platform.MyLink].includes(nativeApi.name)
              ? CapiActionSource.APP
              : CapiActionSource.WEBSITE,
            eventName,
            customData: { ...eventParam, contentName: eventName },
            eventSourceUrl: location.href,
            eventTime: Date.now(),
            userData: {
              clientUserAgent: navigator.userAgent,
            },
          }).then(() => {});
          break;
      }
    });
  };

  if (!isLCPDetermined) {
    console.log('🎯 LCP确定前：最大限度优化性能，使用requestIdleCallback');
    // 🎯 LCP确定前：最大限度优化性能，使用requestIdleCallback
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(executeFun, { timeout: 2000 });
    } else {
      setTimeout(executeFun, 0);
    }
  } else {
    // ⚡ LCP确定后：使用微任务保证数据及时性
    Promise.resolve().then(executeFun);
  }
};

// 進行用戶id的綁定，在CreFIT中則不進行綁定（因為CreFIT中原生已經綁定）
export const sensorTrackUserInfo = async (userId?: string) => {
  if (nativeApi.name === Platform.Crefit) return;
  if (userId) {
    sensors.login(userId);
  } else {
    const userInfo = await getGlobalUserInfo();
    sensors.login(userInfo.userId);
  }
};

/**
 * byClaude-start
 * 处理贷款报告评分上报逻辑：调用kkBridgeCall进行上报
 */
export const handleApplyLoanReportScore = async () => {
  try {
    const userInfo = await getGlobalUserInfo();
    const res = await checkGoogleScoreReport(userInfo.userId);
    if (res.needTracking && res.scoreValue !== null) {
      if (kkBridgeHasMethod('eventTrack')) {
        kkBridgeCall('eventTrack', {
          platform: ['FIREBASE'],
          eventName: 'Apply_Loan_Report_Score',
          eventParam: {
            value: res.scoreValue,
            currency: 'HKD',
            TU_Score: res.scoreValue,
            userId: res.userId,
            scoreTime: res.scoreTime || '',
          },
        });
      }
    }
  } catch (error) {
    console.error('handleApplyLoanReportScore error:', error);
  }
};
// byClaude-end
